import cleanedFilename from '~/util/cleanedFilename';

export default {
  TOGGLE_BUTTON: `${cleanedFilename(__filename)}-toggle-button`,
};
